<template>
  <VueDraggableResizable class="osk-section" drag-handle=".drag" :x="left" :y="top" :w="width" :h="height" @resizing="resize" @dragging="drag" @dragstop="dragStop">
    <div class="drag"><i class="fas fa-bars"></i></div>
    <div class="close-btn" @click="hide"><i class="fas fa-times"></i></div>
    <vue-touch-keyboard class="osk" :options="options" :layout="layoutComputed" :cancel="hide" :accept="accept" :input="selectedInput" />
  </VueDraggableResizable>
</template>

<script>
import KeysLayout from './keyboard_layouts.js';
import VueTouchKeyboard from 'vue-touch-keyboard';
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'; // load default style
import VueDraggableResizable from 'vue-draggable-resizable';
import Vue from 'vue';
Vue.use(VueTouchKeyboard);

export default {
  name: 'OSK',

  props: ['selectedInput', 'layout', 'storedTop', 'storedLeft', 'storedWidth', 'storedHeight'],

  components: { VueDraggableResizable },

  data() {
    return {
      input: null,
      options: {
        useKbEvents: false,
        preventClickEvent: false,
      },
      top: 0,
      left: 0,
      width: 620,
      height: 280,
    };
  },
  computed: {
    layoutComputed() {
      return KeysLayout[this.layout];
    },
  },
  methods: {
    accept(text) {
      // console.log('accept', text);
      this.hide();
    },

    hide() {
      this.$emit('hide');
    },

    inputChanged(e) {
      // console.log('OSK inputChanged', e.target.value);
    },

    drag(left, top) {
      this.left = left;
      this.top = top;
    },
    dragStop() {
      this.$emit('dragstop', this.top, this.left);
    },
    resize(left, top, width, height) {
      this.left = left;
      this.top = top;
      this.width = width;
      this.height = height;
    },
  },
  mounted() {
    this.input = this.selectedInput;
    this.top = this.storedTop;
    this.left = this.storedLeft;
  },
};
</script>

<style scoped lang="scss">
.osk-section {
  pointer-events: auto;
  padding: 10px 20px 0;
  z-index: 1000;

  background: #222;
  border-radius: 10px;
  .drag {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    // background: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: white;
      transform: scaleX(2);
    }
  }
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    // background: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: white;
      font-size: 1.3rem;
    }
  }
  .osk {
    margin-top: 50px;
  }
}
input {
  position: absolute;
  top: -100px;
  width: 100%;
  height: 50px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 12px 20px;
  box-sizing: border-box;
}
</style>